package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.DeliveryDraft
import com.milta.feature.route.domain.entity.RouteCreationResult
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/me — MIL-33 "Créer / Optimiser ma tournée" (driver self-service). */
class CreateOwnRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(deliveries: List<DeliveryDraft>, date: String? = null): RouteCreationResult =
        repository.createOwnRoute(deliveries, date)

    /** MIL-97 — with the driver's GPS position; both null when unavailable or refused. */
    suspend operator fun invoke(
        deliveries: List<DeliveryDraft>,
        date: String?,
        latitude: Double?,
        longitude: Double?,
    ): RouteCreationResult = repository.createOwnRoute(deliveries, date, latitude, longitude)
}
